/** 合作商信息 */
import React, { FC } from 'react'
import { Modal, Descriptions, Spin } from 'antd'
import { useFetch } from 'zn-common'
import { getAgentInfo } from '../service'

interface IAgent {
  agentName: string
  agentId: string
  linkUserName: string
  linkUserPhone: string
  linkUserEmail: string
  createdDate: string
  type: string
  status: string
  agentSecret: string
  salt: string
}

enum AgentSatus {
  '正常',
  '冻结',
  '未认证',
  '已认证',
}

enum AgentTyoe {
  '个人开发者' = 1,
  '企业',
  '合作商',
}

interface IProps {
  onClose: () => void
}

const  UserInfo: FC<IProps> = ({ onClose }) => {

  const [agent] = useFetch(getAgentInfo, {params: {}, initData: {} as IAgent}, { getDataOnmount: true })

  return (
    <Modal
      visible
      title="合作商信息"
      onCancel={() => onClose()}
      footer={null}
      maskClosable={false}
    >
      <Spin spinning={agent.loading}>
        <Descriptions column={1}>
          <Descriptions.Item label="合作商名称">{agent.value.agentName}</Descriptions.Item>
          <Descriptions.Item label="合作商ID">{agent.value.agentId}</Descriptions.Item>
          <Descriptions.Item label="联系人名称">{agent.value.linkUserName}</Descriptions.Item>
          <Descriptions.Item label="联系人手机号">{agent.value.linkUserPhone}</Descriptions.Item>
          <Descriptions.Item label="联系人邮箱">{agent.value.linkUserEmail}</Descriptions.Item>
          <Descriptions.Item label="加入时间">{agent.value.createdDate}</Descriptions.Item>
          <Descriptions.Item label="状态">{AgentSatus[agent.value.status]}</Descriptions.Item>
          <Descriptions.Item label="类型">{AgentTyoe[agent.value.type]}</Descriptions.Item>
          <Descriptions.Item label="密钥">{agent.value.agentSecret}</Descriptions.Item>
          <Descriptions.Item label="盐值">{agent.value.salt}</Descriptions.Item>
        </Descriptions>
      </Spin>
    </Modal>
  )
}

export default UserInfo

